import * as PIXI from 'pixi.js';
import 'pixi-particles';
import {
    SyncQueue,
} from '_pixiSrc/media/loaders';
import ExternalAPI from '_pixiSrc/external/default';
import AssetsLibrary from '_pixiSrc/media/AssetsLibrary';
import I18 from '_pixiSrc/I18';
import {
    Utils,
} from '_pixiSrc/Utils';
import LoaderUI from './LoaderUI';

import Game from './Game';
import {
    ASSETS_PATH, ASSETS_VERSION,
} from './Constants';

import GameData from './ui/GameData';
import DynamicData from './ui/DynamicData';
import NetworkController from './network/NetworkController';

import PACKAGE from '../../package.json';
import CONFIG from './config/config.json';
import ASSETS from './config/assets.json';

//----------------------------------------------------------------------------------------------------------------------
export default function (API = ExternalAPI, apiConfig = {}) {
    const external = new API(apiConfig);
    embedCss(`${ASSETS_PATH.STYLES}/style.css`);

    external.init((external) => {
        const GET = Utils.parseGet();

        const APP = new Game(PACKAGE.name, CONFIG, external);
        APP.once('ready', appReady);
        APP.init(document.body);

        createDecor();

        function appReady() {
            GameData.load(() => {
                DynamicData.init();

                GameData.setProperty('demoPlay', !!GET.demoPlay);

                I18.supportedLanguages = ['en', 'de', 'es', 'fr', 'it', 'nl', 'pl', 'ru', 'tr', 'cs'];
                const locale = GET.locale ? GET.locale.substr(0, 2) : GameData.getProperty('localization');
                I18.init(locale, ASSETS_PATH.LANGUAGE);

                if (GET.sound) {
                    GameData.setProperty('soundEnabled', !!(GET.sound * 1));
                    GameData.setProperty('musicEnabled', !!(GET.sound * 1));
                }


                I18.load(() => {
                    NetworkController.normalizeStartingParams((data) => {
                        let bitmapScale = 1.5;

                        if (GET.animation) {
                            bitmapScale = GET.animation > 1 ? 2 : 1.5;
                        } else {
                            bitmapScale = (data && data.animationStatus > 1) ? 2 : 1.5;
                        }

                        APP.layout.bitmapScale = bitmapScale;
                        APP.library = new AssetsLibrary(ASSETS_PATH.IMAGES, bitmapScale, ASSETS_VERSION);

                        startLoad();
                    });
                });
            });
        }

        function startLoad() {
            const loader = new SyncQueue();

            const loaderUI = new LoaderUI(APP.layout, loader);
            loaderUI.once('complete', preloadComplete);

            const languages = ['en', 'de', 'es', 'fr', 'it', 'nl', 'pl', 'ru', 'tr', 'cs'];
            const GET = Utils.parseGet();
            let locale = GET.locale ? GET.locale.substr(0, 2) : '';
            if (languages.indexOf(locale) < 0) {
                locale = languages[0];
            }

            setTimeout(() => {
                loader.add(
                    APP.library.createLoaderQueue(ASSETS['new-buttons']),
                    APP.library.createLoaderQueue(ASSETS[`new-buttons-${locale}`]),
                    APP.library.createLoaderQueue(ASSETS.paytable),
                    APP.library.createLoaderQueue(ASSETS[`paytable-${locale}`]),
                    APP.library.createLoaderQueue(ASSETS[`assets-${locale}`]),
                    APP.library.createLoaderQueue(ASSETS[`error-${locale}`]),
                    APP.library.createLoaderQueue(ASSETS.images),
                    APP.library.createLoaderQueue(ASSETS.mobileUI),
                    APP.audio.createLoaderQueue(ASSETS.sounds, ASSETS_PATH.SOUNDS),
                );
                loader.load();
            }, 100);
        }

        /** *** DECOR **** */

        function createDecor() {
            const bg = document.getElementsByClassName('p2m-layer-screens')[0];
            bg.style.background = `url(${ASSETS_PATH.IMAGES}/Background.png)`;
            bg.style.backgroundSize = 'cover';
            bg.style.backgroundRepeat = 'no-repeat';
            bg.style.backgroundPosition = '50%';
        }

        function resizeDecor() {
            const canvas = document.getElementsByClassName('p2m-screen')[0];
            const canvasWidth = canvas.offsetWidth;
            const scale = document.documentElement.clientHeight / 1080;
            const screenWidth = document.documentElement.clientWidth;

            let el = document.getElementById('decor_left');
            if (!el) { return; }

            const w = Math.round(360 * scale);
            el.style.width = `${w}px`;
            el.style.height = `${document.documentElement.clientHeight}px`;
            el.style.right = `${Math.round((screenWidth - canvasWidth) / 2 + canvasWidth - 2)}px`;

            el = document.getElementById('decor_right');
            el.style.width = `${Math.round(360 * scale)}px`;
            el.style.height = `${document.documentElement.clientHeight}px`;
            el.style.left = `${Math.round((screenWidth - canvasWidth) / 2 + canvasWidth)}px`;
        }

        APP.layout.on('fitlayout', resizeDecor);
        APP.resizeDecor = resizeDecor;

        window.GD_OPTIONS = {
            gameId: 'c1a7b8245545411b83603e76e5c2c0f8',
            onEvent: (event) => {
                switch (event.name) {
                    case 'SDK_GAME_START':
                        APP.currentWindow.sdkGameStart();
                        break;
                    case 'SDK_GAME_PAUSE':
                        APP.currentWindow.sdkGamePause();
                        break;
                    case 'SDK_GDPR_TRACKING':
                        // this event is triggered when your user doesn't want to be tracked
                        console.log('SDK_GDPR_TRACKING');
                        break;
                    case 'SDK_GDPR_TARGETING':
                        // this event is triggered when your user doesn't want personalised targeting of ads and such
                        console.log('SDK_GDPR_TARGETING');
                        break;
                }
            },
        };

        (function (d, s, id) {
            const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            const js = d.createElement(s);
            js.id = id;
            js.src = 'https://html5.api.gamedistribution.com/main.min.js';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'gamedistribution-jssdk'));

        function preloadComplete(e) {
            APP.run();
            // APP.currentWindow.showAds(true);
        }
    });

    /**
    * add css
    * @param src path for css file
    * @description append css file
    */
    function embedCss(src) {
        const linkElement = document.createElement('link');
        linkElement.type = 'text/css';
        src += `?v=${Math.random()}`;
        linkElement.href = src;
        linkElement.rel = 'stylesheet';
        document.getElementsByTagName('head')[0].appendChild(linkElement);
    }
}
